module.exports = __webpack_public_path__ + "img/forsmax_front.22dd85c7.jpeg";